import React, { useState, useEffect } from "react";
import ScrollFloat from './ScrollFloat';

function InBlog() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Calculate reading time
  const calculateReadingTime = (content) => {
    const wordsPerMinute = 200;
    const wordCount = content.split(" ").length;
    return Math.ceil(wordCount / wordsPerMinute);
  };

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-GB', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${day} ${month}, ${year}`;
  };

  useEffect(() => {
    fetch("https://www.pixelliongroup.com/seotic/getBlogs.php") // Replace with your actual PHP file URL
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (Array.isArray(data)) {
          setBlogs(data.slice(0, 3)); // Limit to the first 3 blog posts
        } else {
          throw new Error("Expected an array but received something else");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching blogs:", error);
        setError(error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <>
        <div className="bg-slate-100 h-full">
          <div className="container mx-auto py-12">
            <div className="text-center"><i className='bx bx-circle bx-burst bx-rotate-270 bx-fw'></i>Loading...</div>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      <div className="bg-slate-100 h-full">
        <div className="container mx-auto pt-20">
         <div className="flex flex-col justify-center items-center mb-10">
          <h2 className="text-center text-base/7 uppercase text-slate-400">Blog</h2>
      <p className="mx-auto mt-2 max-w-lg text-center text-4xl font-semibold tracking-tight text-balance text-gray-950 sm:text-5xl">
        
         <ScrollFloat
          animationDuration={1}
          ease='back.inOut(2)'
          scrollStart='center bottom+=50%'
          scrollEnd='bottom bottom-=40%'
          stagger={0.03}
        >Learn, inspire and always up to date
        </ScrollFloat>
      </p>
        </div>

          <div className="grid gap-5 md:grid-cols-3 mx-5 md:mx-0">
            {blogs.map((post) => (
              <a
                key={post.parama}
                href={`/blog/${post.parama}`} // Link by slug (parama)
                className="bg-white rounded overflow-hidden border border-slate-200"
              >
                <img loading="lazy" className="w-full object-cover" src={post.image} alt={post.title} />
                <div className="px-10 py-5">
                  <p className="text-slate-400 text-sm mb-5">
                    {formatDate(post.date)} in {post.category} • {calculateReadingTime(post.content)} min read
                  </p>
                  <h2 className="text-xl font-medium mb-2">{post.title}</h2>
                  <p className="text-slate-500 text-sm mb-4">{post.description}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
        <div className="flex flex-col justify-center items-center mt-20 mb-10">
          <h2 className="text-center text-base/7 uppercase text-slate-400">Clean & Easy</h2>
      <p className="mx-auto mt-2 max-w-lg text-center text-4xl font-semibold tracking-tight text-balance text-gray-950 sm:text-5xl">
      <ScrollFloat
          animationDuration={1}
          ease='back.inOut(2)'
          scrollStart='center bottom+=50%'
          scrollEnd='bottom bottom-=40%'
          stagger={0.03}
        >Clean, easy to use and built for non tech users
        </ScrollFloat>
    
      </p>
      
     
      
  <div class="md:w-full mx-5 max-w-3xl rounded-lg border border-slate-300 bg-slate-50 pt-3 p-2 mt-10 -mb-10  md:mx-0">
 
    <div class="relative flex items-center justify-center">
   
      <div class="absolute left-2 flex space-x-1">
     
       <p class="h-2 w-2 rounded-full bg-slate-300 hover:bg-yellow-500"></p>
        <p class="h-2 w-2 rounded-full bg-slate-300 hover:bg-green-500"></p>
        <p class="h-2 w-2 rounded-full bg-slate-300 hover:bg-blue-500"></p>
        
      </div>
      
      <p class="text-center text-xs text-slate-400">https://www.seotic.co</p>
    </div>
   
   
    <div class="mt-2">
      <img
        class="w-full rounded-md border border-slate-300 shadow-sm"
        src="/seotic-s01.png"
        alt="Seotic Screen"
      />
    </div>
  </div>
  
  

        </div>

          
      </div>
      


    </>
  );
}

export default InBlog;
